import { MapToContext } from '@utils/objectWithDefault'

export class UserStore {
  constructor (storeItemData) {
    const defaultStoreItemData = {
      id: { val: 0, type: Number },
      StoreName: { val: '', type: String },
      ShipStartDate: { val: null, type: String },
      ShipStartDateTime: { val: null, type: Date },
      PullOrdersLookBackDays: { val: 0, type: Number },
      PlatformSourceEnum: { val: 0, type: Number },
      PlatformSourceDisplay: { val: '', type: String }
    }
    MapToContext(this, defaultStoreItemData, storeItemData)
    this.processShipStartDate(storeItemData.ShipStartDate)
  }
  processShipStartDate (startDateString) {
    const numberPattern = /\d+/g
    const epoch = startDateString.match(numberPattern)[0]
    var shipDateObj = new Date(0)
    this.ShipStartDateTime = new Date(shipDateObj.setUTCMilliseconds(epoch))
  }
}
